import React from "react"
import EditForm from "./EditForm"

export default function EditModal(props) {
  return <EditForm flag={props.flag} asModal={true} {...props} />
}
